import { effects } from 'redux-saga'

import callWithHmac from 'internal-components/src/redux/sagas/effects/callWithHmac'
import handleViolations from 'internal-components/src/redux/sagas/effects/handleViolations'
import { receiveSignup } from 'internal-components/src/redux/modules/signup/actions'
import {
  addErrors,
  beginWork,
  clearErrors,
  editSignup,
  endWork,
} from '../../modules/signupEdit/actions'

export default function* applyCoupon({ invocation }) {
  try {
    yield effects.put.resolve(beginWork())
    yield effects.put.resolve(clearErrors())

    const state = yield effects.select()

    const signup = state.signupEdit.get('edit')
    const result = yield effects.call(
      callWithHmac,
      invocation.signupCoupon,
      signup,
      signup.coupon,
    )

    yield effects.put.resolve(receiveSignup(result.signup))
    yield effects.put.resolve(editSignup(result.signup.id))

    return true
  } catch (e) {
    yield effects.call(handleViolations, e, addErrors)
  } finally {
    yield effects.put.resolve(endWork())
  }

  return false
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/applyCoupon.js